"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEmptyControlCostRow = exports.buildControlCostColumn = exports.buildControlCostIRows = exports.EditableControlCostRow = exports.TableCellControlCostRow = exports.TableCellDataControlCostRow = exports.EditableRowsTable = void 0;
var generic_1 = require("../generic");
var React = require("react");
var buttons_1 = require("../buttons");
var columns_1 = require("./columns");
var editableCell_1 = require("./editableCell");
var tablecells_1 = require("./tablecells");
var inputComponents_1 = require("./inputComponents");
var EditableRowsTable = (function (_super) {
    __extends(EditableRowsTable, _super);
    function EditableRowsTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showCreateRow: false,
        };
        return _this;
    }
    EditableRowsTable.prototype.showCreateRow = function () {
        this.setState({
            showCreateRow: true
        });
    };
    EditableRowsTable.prototype.hideCreateRow = function () {
        this.setState({
            showCreateRow: false
        });
    };
    EditableRowsTable.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(buttons_1.ActionButton, { onClick: function () {
                    _this.showCreateRow();
                }, disabled: !this.props.canCreateRow },
                React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                this.props.createButtonDescription),
            React.createElement("table", { className: "EditableRowsTable table table-bordered" },
                React.createElement("tbody", null,
                    this.state.showCreateRow && dispatchEditableRow({
                        row: this.props.emptyRow,
                        column: this.props.column,
                        field: this.props.emptyRow.fields[0],
                        performRowCreate: function (obj) {
                            return _this.props.performRowCreate(obj).then(function () { return _this.hideCreateRow(); });
                        },
                        cancelButtonHandler: function () { return _this.hideCreateRow(); },
                        refetchTable: this.props.refetchTable,
                    }, 0),
                    this.props.rows.map(function (row, i) {
                        return dispatchEditableRow({
                            row: row,
                            column: _this.props.column,
                            field: row.fields[0],
                            performRowCreate: _this.props.performRowCreate,
                            performRowUpdate: function (data) { return _this.props.performRowUpdate(row.id, data); },
                            performRowDelete: _this.props.performRowDelete,
                            refetchTable: _this.props.refetchTable,
                        }, i + 1);
                    }))));
    };
    return EditableRowsTable;
}(React.Component));
exports.EditableRowsTable = EditableRowsTable;
function dispatchEditableRow(props, key) {
    var column = props.column;
    if (column instanceof columns_1.ControlCostRowColumn) {
        return React.createElement(EditableControlCostRow, __assign({ key: key }, props));
    }
    else {
        console.error("Unknown editable row type: " + column.id);
        throw new Error("Unknown editable row type: " + column.id);
    }
}
var TableCellDataRow = (function (_super) {
    __extends(TableCellDataRow, _super);
    function TableCellDataRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableCellDataRow;
}(tablecells_1.TableCellData));
var TableCellRow = (function (_super) {
    __extends(TableCellRow, _super);
    function TableCellRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableCellRow;
}(tablecells_1.TableCell));
var BaseEditableRow = (function (_super) {
    __extends(BaseEditableRow, _super);
    function BaseEditableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            editMode: !props.field.id,
            field: props.field,
        };
        return _this;
    }
    BaseEditableRow.prototype.getRowCellsDisplayMode = function () {
        console.error("There are no columns in this row");
        return (React.createElement(React.Fragment, null));
    };
    BaseEditableRow.prototype.getRowCellsEditMode = function () {
        console.error("There are no columns in this row");
        return (React.createElement(React.Fragment, null));
    };
    BaseEditableRow.prototype.cancelButtonHandler = function () {
        if (this.props.cancelButtonHandler)
            this.props.cancelButtonHandler();
        if (this.state.field.id)
            this.triggerEditMode();
    };
    BaseEditableRow.prototype.saveButtonHandler = function () {
        console.error("No Save handler is defined for this row type");
        this.triggerEditMode();
    };
    BaseEditableRow.prototype.submitData = function (newField, values) {
        var _this = this;
        if (this.state.field.id) {
            if (this.props.performRowUpdate) {
                this.props.performRowUpdate(values).then(function () { _this.onDataAccepted(newField); }, function () { _this.triggerEditMode(); });
            }
            else {
                console.warn("performRowUpdate is not defined");
            }
        }
        else {
            if (this.props.performRowCreate) {
                this.props.performRowCreate(values).then(function () { _this.onDataAccepted(newField); }, function () { _this.triggerEditMode(); });
            }
            else {
                console.warn("performRowCreate is not defined");
            }
        }
    };
    BaseEditableRow.prototype.onDeleteRow = function (e) {
        var _this = this;
        if (this.props.performRowDelete) {
            this.props.performRowDelete(this.props.row.id).then(function () { return _this.props.refetchTable(); });
        }
        else {
            console.warn("performRowDelete is not defined");
        }
    };
    BaseEditableRow.prototype.renderField = function () {
        if (!this.state.field.id)
            return this.renderInput();
        return (React.createElement("tr", null,
            this.getRowCellsDisplayMode(),
            React.createElement("td", null,
                React.createElement("div", { className: "btn-group", role: "group" },
                    React.createElement(buttons_1.ActionButton, { onClick: this.onClick.bind(this) },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.edit })),
                    React.createElement(buttons_1.ActionButton, { onClick: this.onDeleteRow.bind(this) },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.delete }))))));
    };
    BaseEditableRow.prototype.renderInput = function () {
        var _this = this;
        return (React.createElement("tr", null,
            this.getRowCellsEditMode(),
            React.createElement("td", null,
                React.createElement("button", { className: "btn btn-primary d-inline", onClick: function (e) { return _this.saveButtonHandler(); } }, gettext("Save")),
                React.createElement("button", { className: "btn d-inline", onClick: function (e) { return _this.cancelButtonHandler(); } }, gettext("Cancel")))));
    };
    return BaseEditableRow;
}(editableCell_1.BaseEditableCell));
var TableCellDataControlCostRow = (function (_super) {
    __extends(TableCellDataControlCostRow, _super);
    function TableCellDataControlCostRow(cost) {
        var _this = _super.call(this) || this;
        _this.cost = cost;
        _this.current_value = cost.value ? cost.value.toString() : null;
        _this.current_risk_target = cost.risk_target ? cost.risk_target.toString() : null;
        return _this;
    }
    return TableCellDataControlCostRow;
}(TableCellDataRow));
exports.TableCellDataControlCostRow = TableCellDataControlCostRow;
var TableCellControlCostRow = (function (_super) {
    __extends(TableCellControlCostRow, _super);
    function TableCellControlCostRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableCellControlCostRow;
}(TableCellRow));
exports.TableCellControlCostRow = TableCellControlCostRow;
var EditableControlCostRow = (function (_super) {
    __extends(EditableControlCostRow, _super);
    function EditableControlCostRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditableControlCostRow.prototype.getFieldData = function () {
        return this.state.field.data;
    };
    EditableControlCostRow.prototype.getRowCellsDisplayMode = function () {
        var cost = this.getFieldData().cost;
        return (React.createElement(React.Fragment, null,
            React.createElement("td", null,
                React.createElement("div", { className: "mt-2" }, cost.risk_target_name)),
            React.createElement("td", null,
                React.createElement("div", { className: "mt-2" },
                    cost.value,
                    " ",
                    cost.unit))));
    };
    EditableControlCostRow.prototype.cancelButtonHandler = function () {
        if (this.props.cancelButtonHandler)
            this.props.cancelButtonHandler();
        if (this.state.field.id) {
            var data = this.getFieldData();
            data.current_value = data.cost.value.toString();
            data.current_risk_target = data.cost.risk_target.toString();
            this.triggerEditMode();
        }
    };
    EditableControlCostRow.prototype.saveButtonHandler = function () {
        var data = this.getFieldData();
        var values = {
            control: data.cost.control,
            risk_target: parseInt(data.current_risk_target),
            value: parseFloat(data.current_value),
        };
        if (isNaN(values.value) || isNaN(values.risk_target)) {
            this.cancelButtonHandler();
            notification(gettext("Value: This field must be a number."), { 'type': 'error' });
            return;
        }
        data.cost.value = values.value;
        data.cost.risk_target = values.risk_target;
        var newField = new TableCellControlCostRow(this.state.field.id, data, null, null);
        this.submitData(newField, values);
    };
    EditableControlCostRow.prototype.getRowCellsEditMode = function () {
        var _this = this;
        var data = this.getFieldData();
        var cost = data.cost;
        var ownTarget = cost.id ?
            [{ display_name: "".concat(cost.risk_target_name, " (").concat(cost.unit, ")"), value: cost.risk_target.toString() }]
            : [];
        if (!data.current_risk_target && this.props.column.options.length) {
            data.current_risk_target = this.props.column.options[0].value;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("td", null,
                React.createElement(generic_1.ChoiceSelect, { choices: ownTarget.concat(this.props.column.options.map(function (c) { return c; })), value: data.current_risk_target, onChange: function (e) {
                        var target_id = e.currentTarget.value;
                        _this.setState(function (prevState) {
                            prevState.field.data.current_risk_target = target_id;
                            return {
                                field: new TableCellControlCostRow(prevState.field.id, prevState.field.data, prevState.field.display, prevState.field.fieldName)
                            };
                        });
                    } })),
            React.createElement("td", null,
                React.createElement(inputComponents_1.InputNumber, { value: data.current_value, pattern: "^[\\-+]?[\\d]*[\\.]?[\\d]*$", placeholder: "0.000", onChange: function (e) {
                        var value = e.currentTarget.value;
                        _this.setState(function (prevState) {
                            prevState.field.data.current_value = value;
                            return {
                                field: new TableCellControlCostRow(prevState.field.id, prevState.field.data, prevState.field.display, prevState.field.fieldName)
                            };
                        });
                    } }))));
    };
    return EditableControlCostRow;
}(BaseEditableRow));
exports.EditableControlCostRow = EditableControlCostRow;
function buildControlCostIRows(controlCosts) {
    return controlCosts.map(function (cost) {
        var data = new TableCellDataControlCostRow(cost);
        return {
            id: cost.id,
            fields: [new TableCellControlCostRow(cost.id, data, null, null)],
            url: null,
        };
    });
}
exports.buildControlCostIRows = buildControlCostIRows;
function buildControlCostColumn(availableRiskTargets) {
    return (0, columns_1.dispatchColumn)({
        id: '_control_cost',
        type: columns_1.ColumnTypes.CONTROLCOSTROW,
        show_url: false,
        editable: true,
        options: availableRiskTargets
    });
}
exports.buildControlCostColumn = buildControlCostColumn;
function buildEmptyControlCostRow(control) {
    var blankCost = {
        id: null,
        control: control ? control.id : null,
        risk_target: null,
        risk_target_name: null,
        value: null,
        unit: null,
    };
    return {
        id: null,
        fields: [new TableCellControlCostRow(null, new TableCellDataControlCostRow(blankCost), null, null)],
        url: null,
    };
}
exports.buildEmptyControlCostRow = buildEmptyControlCostRow;
